// import { brandlistdata } from "../json/brandlistdata";
// import { dashboarrecentproductddata } from "../json/dashboarddata";
// import { expiredproductdata } from "../json/dashboardexpiredproduct";
// import { salestransaction } from "../json/salesdashboardrecenttranscation";
// import { unitsdata } from "../json/unitsdata";
// import { variantattributesdata } from "../json/variantattributesdata";
// import { warrentydata } from "../json/waarrentydata";
// import { barcodedata } from "../json/barcodedata";
// import { departmentlistdata } from "../json/departmentlistdata";
// import { designationdata } from "../json/designationdata";
// import { shiftlistdata } from "../json/shiftlistdata";
// import { attendenceemployeedata } from "../json/attendence-employeedata";
// import { invoicereportdata } from "../json/invoicereportdata";
// import { salersretrunsdata } from "../json/salesreturn";
// import { quotationlistdata } from "../json/quotationlistdata";
// import { CustomerData } from "../json/customer_data";
// import { SupplierData } from "../json/supplier_data";
// import { ManageStocksdata } from "../json/managestocks_data";
// import { StockTransferData } from "../json/stocktransferdata";
// import { userlisadata } from "../json/users";
// import { rolesandpermission } from "../json/rolesandpermissiondata";
// import { deleteaccountdata } from "../json/deleteaccount";
// import { attandanceadmindata } from "../json/attendanceadmindata";
// import { leavesadmindata } from "../json/leavesadmin";
// import { leavetypedata } from "../json/leavetypedata";
// import { leavedata } from "../json/leavesdata";
// import { expiredproduct } from "../json/expiredproductdata";
// import { lowstockdata } from "../json/lowstockdata";
// import { categorylist } from "../json/categorylistdata";
// import { subcateorydata } from "../json/subcategorydata";
// import { callhistorydata } from "../json/callhistorydata";

// const { productlistdata } = require("../json/productlistdata");

// const initialState = {
//   product_list: [],
//   dashboard_recentproduct: dashboarrecentproductddata,
//   dashboard_expiredproduct: expiredproductdata,
//   saleshdashboard_recenttransaction: salestransaction,
//   brand_list: brandlistdata,
//   unit_data: unitsdata,
//   variantattributes_data: variantattributesdata,
//   warranty_data: warrentydata,
//   barcode_data: barcodedata,
//   departmentlist_data: departmentlistdata,
//   designation_data: designationdata,
//   shiftlist_data: shiftlistdata,
//   attendenceemployee_data: attendenceemployeedata,
//   toggle_header: false,
//   invoicereport_data: invoicereportdata,
//   salesreturns_data: salersretrunsdata,
//   quotationlist_data: quotationlistdata,
//   store_list: [],
//   customerdata: CustomerData,
//   supplierdata: SupplierData,
//   managestockdata: ManageStocksdata,
//   stocktransferdata: StockTransferData,
//   userlist_data: userlisadata,
//   rolesandpermission_data: rolesandpermission,
//   deleteaccount_data: deleteaccountdata,
//   attendanceadmin_data: attandanceadmindata,
//   leavesadmin_data: leavesadmindata,
//   leavetypes_data: leavetypedata,
//   holiday_data: leavedata,
//   expiredproduct_data: expiredproduct,
//   lowstock_data: lowstockdata,
//   categotylist_data: categorylist,
//   subcategory_data: subcateorydata,
//   callhistory_data: callhistorydata,
//   layoutstyledata: localStorage.getItem("layoutStyling"),
//   accessToken: localStorage.getItem('accessToken') || null,
//   inventory_list: []
// };

// const initialState = {
//   product_list: [],
//   dashboard_recentproduct: [],
//   dashboard_expiredproduct: [],
//   saleshdashboard_recenttransaction: [],
//   brand_list: [],
//   unit_data: [],
//   variantattributes_data: [],
//   warranty_data: [],
//   barcode_data: [],
//   departmentlist_data: [],
//   designation_data: [],
//   shiftlist_data: [],
//   attendenceemployee_data: [],
//   toggle_header: false,
//   invoicereport_data: [],
//   salesreturns_data: [],
//   quotationlist_data: [],
//   store_list: [],
//   customerdata: [],
//   supplierdata: [],
//   managestockdata: [],
//   stocktransferdata: [],
//   userlist_data: [],
//   rolesandpermission_data: [],
//   deleteaccount_data: [],
//   attendanceadmin_data: [],
//   leavesadmin_data: [],
//   leavetypes_data: [],
//   holiday_data: [],
//   expiredproduct_data: [],
//   lowstock_data: [],
//   categotylist_data: [],
//   subcategory_data: [],
//   callhistory_data: [],
//   layoutstyledata: localStorage.getItem("layoutStyling"),
//   accessToken: localStorage.getItem('accessToken') || null,
//   inventory_list: [],
//   translation: JSON.parse(localStorage.getItem('translation') || "[]"),
//   language: localStorage.getItem("language") || "en",

//   languages: JSON.parse(localStorage.getItem("languages")) || [{key: "en", name: "English"}],
//   permissions: JSON.parse(localStorage.getItem("permissions")),
//   roleTitle: '',
//   roleTitleAdmin: 'FlowTenantAdmin'
// };
// export default initialState;

const safeJsonParse = (item, defaultValue) => {
  try {
    return JSON.parse(item) || defaultValue;
  } catch (e) {
    return defaultValue;
  }
};

const initialState = {
  product_list: [],
  dashboard_recentproduct: [],
  dashboard_expiredproduct: [],
  saleshdashboard_recenttransaction: [],
  brand_list: [],
  brand_edit: [],
  gateway_list: [],
  unit_data: [],
  variantattributes_data: [],
  warranty_data: [],
  barcode_data: [],
  departmentlist_data: [],
  designation_data: [],
  shiftlist_data: [],
  attendenceemployee_data: [],
  toggle_header: false,
  invoicereport_data: [],
  salesreturns_data: [],
  quotationlist_data: [],
  store_list: [],
  customerdata: [],
  supplierdata: [],
  managestockdata: [],
  stocktransferdata: [],
  userlist_data: [],
  rolesandpermission_data: [],
  deleteaccount_data: [],
  attendanceadmin_data: [],
  leavesadmin_data: [],
  leavetypes_data: [],
  holiday_data: [],
  expiredproduct_data: [],
  lowstock_data: [],
  categotylist_data: [],
  subcategory_data: [],
  callhistory_data: [],
  layoutstyledata: localStorage.getItem("layoutStyling") ||"",
  accessToken: localStorage.getItem('accessToken') || null,
  inventory_list: [],
  translation: safeJsonParse(localStorage.getItem('translation'), []),
  language: localStorage.getItem("language") || "en",
  languages: safeJsonParse(localStorage.getItem("languages"), [{ key: "en", name: "English" }]),
  permissions: safeJsonParse(localStorage.getItem("permissions"), null),
  roleTitle: localStorage.getItem("roleTitle") || "",
  roleTitleAdmin: 'TenantAdmin',
  tenantId: localStorage.getItem("tenantId") || "",
};

export default initialState;
